export const menuItems = [
  {
    type: "parent",
    text: "KONTEN BELAJAR",
    icon: "play-circle",
    children: [
      // {
      //   type: "link",
      //   url: "/test-link",
      //   text: "Test Link",
      //   icon: "play-circle"
      // },

      {
        type: "parent",
        text: "Integral - Teori",
        icon: "play-circle",
        children: [
          {
            type: "link",
            url: "/sma/math/topicID/video/playlistID/videoID1",
            text: "Dasar Integral",
            icon: ["far", "play-circle"],
            info: "5 Menit",
            free: true
          },
          {
            type: "link",
            url: "/sma/math/topicID/video/playlistID/videoID2",
            text: "Teori Integral Part 1",
            icon: ["far", "play-circle"],
            info: "5 Menit"
          },
          {
            type: "link",
            url: "/sma/math/topicID/video/playlistID/videoID3",
            text: "Teori Integral Part 2",
            icon: ["far", "play-circle"],
            info: "5 Menit"
          },
          {
            type: "link",
            url: "/sma/math/topicID/pdf/playlistID/filePDFID4",
            text: "Teori Integral Part 3",
            icon: ["far", "copy"],
            info: "1 Dokumen"
          },
          {
            type: "link",
            url: "/sma/math/topicID/video/playlistID/videoID5",
            text: "Simpulan",
            icon: ["far", "play-circle"],
            info: "2 Menit"
          }
        ],
        expanded: false
      }
    ],
    expanded: false
  },
  {
    type: "link",
    url: "/sma/math/topicID/quiz/quizID1/",
    text: "QUIZ",
    icon: "check-square"
  },
  {
    type: "link",
    url: "/sma/math/topicID/exam/examID2/",
    text: "EXAM",
    icon: "pencil-alt"
  }
];
